import Client from '../AxiosClient';
const resource = '/private/surveys';

export default {
    /**
     * ----------------------------------------------------------------
     * Survey APIs
     * ----------------------------------------------------------------
     */

    async changeOpenSurveyStatus(body){
        try {
            const response = await Client.post(`${resource}/changestatus`, body);
            if(response.data.status === 'failed') {
                return {error: response.data.message};
            }
            return response.data.data[0];
        } catch (error) {
            return {error: error};
        }
    },
    
    /**
     * Lấy danh sách toàn bộ các cuộc khảo sát.
     */
    async getSurveys(account_id) {
        try {
            const surveys = await Client.get(`${resource}/account/${account_id}`);
            return surveys.data.data;
        } catch (error) {
            return {error: error};
        }
    },

    /**
     * Lấy thông tin và nội dung (gồm câu hỏi và các lựa chọn) của một cuộc khảo sát 
     * để người dùng thực hiện khảo sát
     * @param {mã cuộc khảo sát } id 
     */
    async getSurveyById(id) {
        try {
            const survey = await Client.get(`${resource}/${id}`);
            if(survey.data.data.length <= 0) {
                return {};
            }
            return survey.data.data[0];
        } catch (error) {
            return {error: error};
        }
    },

    /**
     * Xóa một khảo sát khỏi hệ thống
     * @param {survey_id} id 
     * @returns 
     */
    async deleteSurveyById(id) {
        try {
            const survey = await Client.delete(`${resource}/${id}`);
            if(survey.data.data.length <= 0) {
                return {};
            }
            return survey.data.data[0];
        } catch (error) {
            return {error: error};
        }
    },

    /**
     * Tạo mới một cuộc khảo sát (bao gồm cả câu hỏi và các lựa chọn)
     * @param {Nội dung cuộc khảo sát} survey 
     */
    async createSurvey(survey) {
        try {
            const response = await Client.post(`${resource}`, survey);
            return response;
        } catch (error) {
            return {error: error}
        }
    },

    /**
     * Submit nội dung mà người dùng đã thực hiện trả lời khảo sát
     * @param {Nội dung mà người dùng thực hiện khảo sát} result 
     */
    async participateSurvey(result) {
        try {
            const response = await Client.post(`${resource}/results`, result);
            return response;
        } catch (error) {
            return {error: error}
        }
    },

    /**
     * Lấy kểt quả tổng kết một khảo sát
     * @param {*} surveyId 
     * @returns 
     */
    async getResults(surveyId) {
        try {
            const result = await Client.get(`${resource}/results/${surveyId}`);
            if(result.data.data.length <= 0) {
                return {};
            }
            return result.data.data[0];
        } catch (error) {
            return {error: error};
        }
    },

    /**
     * ----------------------------------------------------------------
     * Topic APIs
     * ----------------------------------------------------------------
     */

    /**
     * Lấy danh sách toàn bộ nội dung các chủ đề
     */
    async getTopics() {
        try {
            const topics = await Client.get(`${resource}/topics`);
            return topics.data.data;
        } catch (error) {
            return {error: error}
        }
    },

    /**
     * Tạo mới một chủ đề
     * @param {*} topic 
     */
    async createTopic(topic) {
        try {
            const response = await Client.post(`${resource}/topics`, topic);
            return response;
        } catch (error) {
            return {error: error}
        }

    },
    
    /**
     * ----------------------------------------------------------------
     * Group accounts APIs
     * ----------------------------------------------------------------
     */

}